var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Promised", {
    attrs: { promise: _vm.usersPromise },
    scopedSlots: _vm._u([
      {
        key: "pending",
        fn: function () {
          return [_c("p", [_vm._v("Загрузка...")])]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function (data) {
          return [_vm._v("\n    " + _vm._s(data?.name ?? data) + "\n  ")]
        },
      },
      {
        key: "rejected",
        fn: function (error) {
          return [_c("p", [_vm._v("Error: " + _vm._s(error.message))])]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }